module.exports = __webpack_public_path__ + "img/ico_2.9a009a7d.png";